import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Shield, Sparkles, BookOpen, Gift } from 'lucide-react';
export function SolutionSection() {
  return <section id="solucion" className="py-16 px-4 bg-ice-dark relative overflow-hidden border-y border-gold/20" data-id="element-201">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#C5942A_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-202" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-[0_10px_40px_-10px_rgba(27,42,74,0.1)] border border-gold/10 relative" data-id="element-204">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-ice-dark p-4 rounded-full border border-gold/20 shadow-lg" data-id="element-205">
            <Shield className="w-10 h-10 text-gold" data-id="element-206" />
          </div>

          <div className="text-center mt-6 mb-10" data-id="element-207">
            <div className="flex items-center justify-center gap-2 mb-4 text-gold" data-id="element-208">
              <Sparkles className="w-5 h-5" data-id="element-209" />
              <span className="font-body uppercase tracking-widest text-sm font-bold" data-id="element-210">
                La Solución
              </span>
              <Sparkles className="w-5 h-5" data-id="element-211" />
            </div>

            <h2 className="font-heading text-4xl md:text-5xl font-bold text-navy-dark mb-8" data-id="element-212">
              Descubre el Poder del{' '}
              <span className="text-blue" data-id="element-213">Escudo de Fe</span>
            </h2>

            {/* Book Image with "Libro digital" badge */}
            <div className="relative inline-block mb-10" data-id="element-214">
              <img src="https://cdn.magicpatterns.com/uploads/dhKPxStdFGsisRrHHJpGeR/heylloyd-image-1772637616792.png" alt="Escudo de Fe - Manual de Oración Diaria" className="w-64 md:w-80 mx-auto rounded-xl shadow-[0_15px_50px_-10px_rgba(15,29,54,0.4)] border border-gold/20" loading="lazy" data-id="element-215" />
              <div className="absolute -top-3 -right-3 md:-right-6 bg-gradient-to-r from-gold-light to-gold-dark text-navy-dark px-4 py-1.5 rounded-full font-body text-xs font-bold uppercase tracking-wider shadow-lg flex items-center gap-1.5" data-id="element-216">
                <BookOpen className="w-3.5 h-3.5" data-id="element-217" />
                Libro digital
              </div>
            </div>

            {/* Bono Gratis - Acceso Directo */}
            <div className="mb-8 max-w-md mx-auto bg-gradient-to-r from-gold-light/20 to-gold-dark/20 border-2 border-gold rounded-2xl p-6 shadow-[0_0_30px_rgba(197,148,42,0.3)]" data-id="element-218">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-219">
                <Gift className="w-6 h-6 text-gold" data-id="element-220" />
                <span className="font-heading text-lg font-bold text-gold uppercase tracking-wider" data-id="element-221">
                  BONO GRATIS
                </span>
              </div>
              <h4 className="font-heading text-xl font-bold text-navy-dark mb-2 text-center" data-id="element-222">
                Acceso Directo para Peticiones Personales
              </h4>
              <p className="font-body text-base text-navy/80 leading-relaxed text-center" data-id="element-223">
                Contacto directo con La Hermana Teresa R. para pedirle por un
                familiar específico o una oración particular para ti o tu
                familia.
              </p>
            </div>

            <p className="font-body text-xl text-navy leading-relaxed mb-6" data-id="element-224">
              Presentamos el{' '}
              <strong className="text-blue" data-id="element-225">"Escudo de Fe"</strong>, una guía
              espiritual diseñada para fortalecer tu hogar contra los peligros
              externos.
            </p>
            <p className="font-body text-lg text-navy/80 leading-relaxed" data-id="element-226">
              Con esta poderosa herramienta de oración y protección divina,
              sentirás la paz mental que necesitas para enfrentar el día a día,
              sabiendo que tu familia está bajo un manto de seguridad superior.
            </p>
          </div>

          {/* Unique Mechanism Subsection */}
          <div className="pt-12 border-t border-gold/20" data-id="element-227">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-navy-dark mb-8 text-center" data-id="element-228">
              ¿Por qué el Escudo de Fe es diferente?
            </h3>

            <div className="space-y-8" data-id="element-229">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="flex gap-4" data-id="element-230">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold-light/20 border border-gold text-gold-dark flex items-center justify-center font-heading font-bold text-lg" data-id="element-231">
                  1
                </div>
                <div data-id="element-232">
                  <h4 className="font-heading font-bold text-xl text-navy-dark mb-2" data-id="element-233">
                    Oración de Sellamiento Específica
                  </h4>
                  <p className="font-body text-navy/80 leading-relaxed" data-id="element-234">
                    Sella espiritualmente cada punto de tu hogar: puertas,
                    ventanas y cada miembro de la familia con un propósito
                    divino específico.
                  </p>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="flex gap-4" data-id="element-235">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold-light/20 border border-gold text-gold-dark flex items-center justify-center font-heading font-bold text-lg" data-id="element-236">
                  2
                </div>
                <div data-id="element-237">
                  <h4 className="font-heading font-bold text-xl text-navy-dark mb-2" data-id="element-238">
                    Activación Diaria en 5 Minutos
                  </h4>
                  <p className="font-body text-navy/80 leading-relaxed" data-id="element-239">
                    Solo 5 minutos cada mañana para activar un escudo de
                    protección que dura las 24 horas.
                  </p>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="flex gap-4" data-id="element-240">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold-light/20 border border-gold text-gold-dark flex items-center justify-center font-heading font-bold text-lg" data-id="element-241">
                  3
                </div>
                <div data-id="element-242">
                  <h4 className="font-heading font-bold text-xl text-navy-dark mb-2" data-id="element-243">
                    Protección Comprobada por Miles
                  </h4>
                  <p className="font-body text-navy/80 leading-relaxed" data-id="element-244">
                    Más de 4,200 familias ya lo usan. Resultados reales desde el
                    primer día.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Bottom decorative divider (Difuminado) */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-navy-dark to-transparent z-20" data-id="element-245" />
    </section>;
}